export default __webpack_public_path__ + "static/media/datacenters.12153079.png";